import React from 'react';
import { Alert, AlertTitle, CircularProgress, IconButton, Paper, Tooltip, Typography } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';

interface AtokaLinkSectionProps {
	linkAtokaCompany: VoidFunction;
	isLoading?: boolean;
}

export default function AtokaLinkSection(props: AtokaLinkSectionProps) {
	const { t } = useSettings();

	return (
		<Paper className="rounded-8" variant="outlined">
			<Alert
				className="rounded-8"
				severity="info"
				icon={props.isLoading ? <CircularProgress size={24} disableShrink /> : <Icon icon="info-circle" />}
				action={
					<Tooltip title={t('COMPANIES_ATOKA_BUTTON_LINK')} arrow>
						<IconButton onClick={props.linkAtokaCompany}>
							<Icon icon="link-variant" />
						</IconButton>
					</Tooltip>
				}
			>
				<AlertTitle>{t('DETAILS_COMPANIES_ATOKA_SECTION')}</AlertTitle>
				<Typography>{t('DETAILS_COMPANIES_ATOKA_SECTION_DESCRIPTION_NOTLINKED')}</Typography>
				<Typography variant="subtitle2">{t('DETAILS_COMPANIES_ATOKA_SECTION_DESCRIPTION_WARNING')}</Typography>
			</Alert>
		</Paper>
	);
}
